import { AxiosError } from 'axios';
import { AccessToken } from '../../domain/token';
import { PromiseEither } from '../../utils/either';
import ApiClient from './client';

type Notification = {
  permissions: string[];
};

const getNotifications = async (
  accessToken: AccessToken
): PromiseEither<AxiosError<any>, Notification> => {
  const res = await ApiClient.instance.get<Notification>(
    `/user/permission`,
    'wapi',
    accessToken
  );
  return res.map<Notification>(({ data }) => data);
};

const updateNotifications = async (
  userId: number,
  permissions: {
    permission_id: string;
    permitted: boolean;
  }[]
) => {
  await ApiClient.instance.put<string[]>(
    `/user/permission`,
    {
      user_id: userId,
      permissions
    },
    'wapi'
  );
};

export default {
  getNotifications,
  updateNotifications
};
